'use strict';

var React = require('react');
var material = require('@mui/material');
var lodash = require('lodash');
var index = require('../index.js');
require('../../types/brand.js');
require('../../types/cms/enums.js');
var theme = require('../../utils/brands/theme.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Module = ({ uiComponentIdentifier, enablePreviewMode, ModulePreviewTooling, ...rest }) => {
    const Component = lodash.get(index["default"], uiComponentIdentifier);
    const props = {
        ...rest,
        uiComponentIdentifier
    };
    const theme$1 = material.useTheme();
    const brandStyles = theme.getStylesForTarget(theme$1, uiComponentIdentifier);
    if (brandStyles) {
        props.sx = brandStyles;
    }
    if (enablePreviewMode) {
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(ModulePreviewTooling, { componentContext: props },
                React__default["default"].createElement(Component, { ...props }))));
    }
    return React__default["default"].createElement(Component, { ...props });
};

module.exports = Module;
//# sourceMappingURL=Module.js.map
